module.exports = __webpack_public_path__ + "static/media/tutorial-camp.265bca0e.png";